import dynamic from "next/dynamic";

import PassthroughFallback from "@/components/atoms/PassthroughFallback/PassthroughFallback";

const FormRoot = dynamic(() => import("./ClientRoot"), {
  ssr: true,
  loading: PassthroughFallback,
});

export default FormRoot;
